import React, { Component } from "react";
import { Table, Button, Message, Label } from "semantic-ui-react";

class InvoicesPrintReport extends Component {
  render() {

    const { transactions, total } = this.props;
    return (
      <Table celled fixed singleLine>
        <Table.Header>
        <Table.Row>
          <Table.HeaderCell colSpan="5" style={{ textAlign:"center" }}>Invoices Report</Table.HeaderCell>
        </Table.Row>

          <Table.Row>
            <Table.HeaderCell width={1} style={{ textAlign: 'center' }}>Sr</Table.HeaderCell>
            <Table.HeaderCell width={2}>Date</Table.HeaderCell>
            <Table.HeaderCell width={2}>Invoice#</Table.HeaderCell>
            <Table.HeaderCell width={9}>Client</Table.HeaderCell>
            <Table.HeaderCell width={2}>Grand Total</Table.HeaderCell>
          </Table.Row>
        </Table.Header>

        <Table.Body>
          {transactions.map(transaction => (
            <Table.Row>
              <Table.Cell style={{ textAlign: 'center' }}>{transaction.sr}</Table.Cell>
              <Table.Cell>{transaction.invoice_date}</Table.Cell>
              <Table.Cell>{transaction.invoice_number}</Table.Cell>
              <Table.Cell>{transaction.client}</Table.Cell>
              <Table.Cell style={{ textAlign: 'center' }}>{transaction.grand_total}</Table.Cell>
            </Table.Row>
          )
          )}

          {/* <Table.Row>
              <Table.Cell style={{ textAlign:"center" }}></Table.Cell>
              <Table.Cell></Table.Cell>
              <Table.Cell style={{ textAlign:"center" }}></Table.Cell>
              <Table.Cell></Table.Cell>
              <Table.Cell colspan="3" style={{ textAlign:"left",fontSize:'15px' }}><b>{total}</b></Table.Cell>
             
            </Table.Row> */}

        </Table.Body>
      </Table>
    );
  }
}
export default InvoicesPrintReport;
